const $ = require('jquery');

// Make it easier to use jQuery from the console
window.$ = $;

// add our components
require('./components/form.js');
require('./components/form-paged.js');
require('./components/scroll-on-click.js');
require('./components/shadowbox.js');
require('./components/header.js');
require('./components/hero.js');
require('./components/jquery-tabs.js');
require('./components/select-menu.js');
require('./components/service-renewals.js');
require('./components/services.js');
require('./components/slick.js');
require('./components/modal.js');

$( document ).ajaxComplete(function() {
        //if form is submitted capture form
        $( '.webform-ajax-form-wrapper .webform-submission-form .webform-button--submit' ).click(function() {
          console.log('ajax refreshed, submit button clicked')
          triggerFormEvent();
        });

        $('.webform-ajax-form-wrapper .webform-submission-form').keypress(function(event) {
          if (event.which == 13) {
            event.preventDefault();
            triggerFormEvent();
          }
        });


        function triggerFormEvent() {
          if ($('.webform-submission-form').valid() == true) {
            console.log('form is valid, submitting to calltrk');
            CallTrk.captureForm(".webform-submission-form");
          }else{
            console.log('not valid');
          }
        }

      });



$( document ).ready(function() {

  function triggerFormEvent() {
    if ($('.webform-submission-form').valid() == true) {
      console.log('form is valid, submitting to calltrk');
      CallTrk.captureForm(".webform-submission-form");
    }else{
      console.log('not valid');
    }
  }

  //if form is submitted capture form
  $( '.webform-ajax-form-wrapper .webform-submission-form .webform-button--submit' ).click(function() {
    triggerFormEvent();
  });

  //if enter is pressed, capture form
  $('.webform-ajax-form-wrapper .webform-submission-form').keypress(function(event) {
    if (event.which == 13) {
      event.preventDefault();
      triggerFormEvent();
    }

  });

  //culture page
  $( ".the-culture-history .button--green.read-more" ).click(function() {

    var buttonWrapper = $('.the-culture-history .button-wrapper');

    $( ".history-more" ).slideToggle( "slow" );

    var button = $('.the-culture-history .button--green.read-more');
    var button_text = button.html();
    var history_intro = $('.history-intro');

    console.log(button_text)
    if (button_text == 'Read More') {
      button.html('Read Less');
      history_intro.removeClass('faded');
      //append button to end of content
      $('.history-more').append(buttonWrapper);

    }else if(button_text == 'Read Less'){
      button.html('Read More');
      history_intro.addClass('faded');
      //append back to top.
      buttonWrapper.insertAfter( ".history-intro" );
      
    }


  });

  if ($('.history-slider').length) {
    console.log('has history-slider');
    // Init the Slick Slider element when page is ready.
    $('.history-slider').slick({
      mobileFirst:true,
      //lazyLoad: 'ondemand',
      //centerMode: true,
      //centerPadding: '50px',
     // slidesToShow: 3,
      focusOnSelect: true,
      //variableWidth: true,
      //dots: true,
      //infinite: true,
       responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              centerMode: true,

            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]

    });
  }


});

